// extracted by mini-css-extract-plugin
module.exports = {"approvalRules":"ApprovalRules__approvalRules___3JqLA"};